export default "__VITE_ASSET__DHpBBi4x__"